import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchLogSuccess, fetchLogError, addLogSuccess, addLogError} from '../actions/Log';
import { getDocs, addDoc } from 'firebase/services/log';
import {FETCH_LOG, ADD_LOG} from 'constants/ActionTypes';

function* fetchLogRequest({ params }) {
  try {
    const fetchedLogList = yield call(getDocs, { filter: params && params.filter });
    yield put(fetchLogSuccess(fetchedLogList));
  } catch (error) {
    console.log(error);
    yield put(fetchLogError(error));
  }
}

function* addLogRequest({ payload: { params } }) {
  try {
    const result = yield call(addDoc, {data: params});
    yield put(addLogSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(addLogError(error));
  }
}

export function* fetchLog() {
  yield takeEvery(FETCH_LOG, fetchLogRequest);
}

export function* addLog() {
  yield takeEvery(ADD_LOG, addLogRequest);
}


export default function* rootSaga() {
  yield all([fork(fetchLog), fork(addLog)]);
}
